import React, { FC } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { ICollection, IMerchant } from 'src/prize/types/shoppe';

import { Image } from './atoms/Image';

interface IBannerProps {
  collection?: ICollection;
  merchant: IMerchant;
}

export const Banner: FC<IBannerProps> = ({ collection, merchant }) => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Image collection={collection} merchant={merchant} />} />
      <Route
        path="/categories/:name"
        element={<Image collection={collection} merchant={merchant} />}
      />
    </Routes>
  </BrowserRouter>
);
